import { Box, Button, Stack, Typography, keyframes } from "@mui/material"
import { RobotDetailData } from "../types/Robot"
import { useQuery } from "react-query";
import { useEffect, useState } from "react";
import { getRobotDoorStatus, getSimulateRobotTouchScreen, postCloseRobotDoors } from "../api/robot";

const blink = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

export const NotificationYesNo = (props: {
    robot: RobotDetailData | undefined,
    handleNo: () => void,
    handleYes: () => void,
    message: string,
    subtitle: string,
    displayImg: string,
    showYesNo: boolean,
}) => {
    const {robot, handleNo, handleYes, message, subtitle, displayImg, showYesNo} = props
    const [playAudio, setPlayAudio] = useState<boolean>(true);
    const [interacted, setInteracted] = useState<boolean>(true);
    const [doorState, setDoorState] = useState<boolean[]>([false, false, false, false])
    const [dismissed, setDismissed] = useState<boolean>(false)
    const [isPlaying, setIsPlaying] = useState<boolean>(false)

    // useQuery("door", async () => {
    //     if (!interacted && robot) {
    //         const result = await getRobotDoorStatus(robot.id);
    //         setDoorState(result.data);
    //         setInteracted(true);
    //     }
    //     if (interacted && doorState.reduce((prev, curr) => prev && curr, true)) {
    //         // await postCloseRobotDoors(robot.id);
    //         handleLoadedItem()
    //     }
    // }, {
    //     refetchInterval: 1000
    // });

    // useQuery("audio", () => {
    //     // simulate human touch
    //     // const isAnyOpen = doorState.reduce((prev, curr) => prev || curr, false);
    //     // if (!isAnyOpen) {
    //     //     await getSimulateRobotTouchScreen();
    //     // }
    //     if(playAudio) {
    //         audio.play();
    //     }
    // }, {
    //     refetchInterval: 5000
    // })

    useQuery("audioOnce", async () => {
        if (!isPlaying) {
            setIsPlaying(true)
            const audio = new Audio("./assets/sound/robot_is_here.mp3")
            !dismissed && await audio.play();
            setIsPlaying(false)
        }
    },
    {
        refetchInterval: 20000
    })

    // useEffect(()=> {
    //     audio.play();
    // }, [])

    // useEffect(()=> {
    //     const isAnyOpen = doorState.reduce((prev, curr) => prev || curr, false);
    //     setPlayAudio(!isAnyOpen); // play if doors have not been opened yet
    // }, [doorState]);

    const handleNotificationNo = async () => {
        // await postCloseRobotDoors(robot.id);
        setDismissed(true);
        handleNo();
    }

    const handleNotificationYes = async () => {
        // await postCloseRobotDoors(robot.id);
        setDismissed(true);
        handleYes();
    }

    return <>
    {!dismissed && <><Box sx={{
        width: "52%",
        height: showYesNo ? "85%" : "83%",
        backgroundColor: "#F53649",
        position: 'absolute' as 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        borderRadius: "32px",
        animation: `${blink} 0.3s linear infinite`,
        animationDirection: 'alternate',}}/>
    <Stack sx={{
        width: "48%",
        height: showYesNo ? "80%" : "76%",
        backgroundColor: "#FFFFF9",
        justifyContent: "center",
        alignItems: "center",
        position: 'absolute' as 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        borderRadius: "24px",
    }}>
        {robot ? <img src={robot.image} alt={robot.name}/> : <></>}
        {!interacted ? <Typography sx={{
            fontSize: "36px",
            paddingTop: "24px"
        }}>Robot has arrived, please load item into the robot</Typography> :
        <><Typography sx={{
            fontSize: "36px",
            paddingTop: showYesNo ? "0px" : "24px",
            color: "#000000",
            fontWeight: "bold"
        }}>{message}</Typography>
        <Typography sx={{
            fontSize: "24px",
            paddingTop: showYesNo ? "0px" : "16px",
            paddingBottom: showYesNo ? "6px" : "16px",
            color: "#B9B9B9",
        }}>{subtitle}</Typography>
        {showYesNo &&  <Stack direction={"row"}><Button sx={{
            backgroundColor: "#FF0000",
            color: "#F9F9F9",
            borderRadius: "45px",
            fontSize: "24px",
            paddingLeft: "36px",
            paddingRight: "36px",
            paddingTop: "8px",
            paddingBottom: "8px",
            ":hover": {
                backgroundColor: "#FF0000",
            },
            textTransform: "none",
        }} onClick={handleNotificationNo}>No</Button> <Button sx={{
            backgroundColor: "#70ad47",
            color: "#F9F9F9",
            borderRadius: "45px",
            fontSize: "24px",
            marginLeft:"36px",
            paddingLeft: "36px",
            paddingRight: "36px",
            paddingTop: "8px",
            paddingBottom: "8px",
            ":hover": {
                backgroundColor: "#70ad47",
            },
            textTransform: "none",
        }} onClick={handleNotificationYes}>Yes</Button></Stack>}
        </>}
    </Stack>
    </>}
    </>;
}